import certifiedLogos from "./image/certifiedLogos.webp";
import cyberImage from "./image/cybersecurity.jpg"; 
import cyberImage2 from "./image/cybersecurity2.jpg"; 
import approachImg from "./image/approach-img.jpg"; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useState } from 'react';


function About() {
  const [activeTab, setActiveTab] = useState('OfficeNetworks');

  return (
    <div>
      <div className="page-banner-area">
      <h2>About Page</h2>
      <p>This is the about page content.</p>
      </div>

        {/* -- DESCRIBE ABOUT US ------ */}

          <div className="about-us-main-wrap">
              <div className="container">
                 <div className="row">
                  <div className="col-lg-5">
                        <div className="about-usright-content">
                        <img src={cyberImage} alt="cybersecurity" />
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="about-usleft-content">
                         <h2>Complete Cybersecurity Protection for Your Business</h2>
                         <p>At Pranasrishti Solutions, we deliver end-to-end cybersecurity solutions designed to safeguard every part of your digital ecosystem. Our approach goes far beyond traditional protection, combining cutting-edge technology, industry best practices, and expert intelligence to keep your organization safe from evolving cyber threats.
                          Whether you’re a growing startup, mid-sized business, or large enterprise, our solutions are built to scale with your needs. From data protection and network security to application defense and compliance management, we ensure your business is resilient against even the most sophisticated attacks.<br/>
                          With us, you get:
                          </p>
                      </div>
                    </div>
                 </div>
                 <div className="about-usleft-content">
                            <div class="row pt-4 ">
                              <div class="col-lg-3 col-sm-6">
                                <div class="single-security">
                                  <i class="fa-solid fa-arrows-down-to-people"></i>
                                  <h3>Comprehensive Coverage</h3>
                                  <p>Protection for data, applications, networks, cloud, and endpoints.</p>
                                </div>
                              </div>
                              <div class="col-lg-3 col-sm-6">
                                <div class="single-security">
                                  <i class="fa-solid fa-shield-halved"></i>
                                  <h3>Advanced Threat Prevention</h3>
                                  <p>Proactive defense against ransomware, phishing, malware, and zero-day exploits.</p>
                                </div>
                              </div>
                              <div class="col-lg-3 col-sm-6">
                                <div class="single-security mb-0 mb-rs-need">
                                 <i class="fa-solid fa-table"></i>
                                  <h3>Compliance Made Simple</h3>
                                  <p>Stay aligned with GDPR, HIPAA, PCI DSS, and ISO 27001 without the complexity.</p>
                                </div>
                              </div>
                              <div class="col-lg-3 col-sm-6">
                                <div class="single-security mb-0">
                                 <i class="fa-solid fa-shield-halved"></i>
                                  <h3>Scalable Security</h3>
                                  <p>Flexible solutions designed for businesses of every<br/> size.</p>
                                </div>
                              </div>
                            </div>
                            </div>
              </div>
          </div>

        

           <div className="about-us-main-wrap">
              <div className="container">
                 <div className="row">
                    <div className="col-lg-7">
                      <div className="about-usleft-content">
                         <h2>Smart, Seamless Protection for Your Business</h2>
                         <p>In today’s digital-first world, your business needs security that is intelligent, adaptable, and always within your control. At Pranasrashti Solutions, we provide innovative electronic protection combined with intelligent online controls to secure every aspect of your digital environment.
                         Our solutions go beyond traditional security by ensuring that your business is protected at every layer:</p>
                          {/* Tabs */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "OfficeNetworks", label: "OfficeNetworks" },
                      { id: "Applications", label: "Applications" },
                      { id: "SmartDevices", label: "SmartDevices" },
                      { id: "CloudDataSecurity", label: "CloudDataSecurity" },
                      { id: "RealMonitoringAlerts", label: "RealMonitoringAlerts" },

                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* OfficeNetworks */}
                    <div className={`tab-pane fade${activeTab === "OfficeNetworks" ? " show active" : ""}`} role="tabpanel">
                      <p>Your office network is the backbone of your business. We secure it against unauthorized access, data breaches, and advanced cyber threats, ensuring uninterrupted operations. From firewalls and intrusion prevention to segmentation and access control, we give you a fortified, resilient network environment.</p>      
                    </div>

                    {/* Applications */}
                    <div className={`tab-pane fade${activeTab === "Applications" ? " show active" : ""}`} role="tabpanel">
                     <p>Your applications power your business—and attackers know it. We protect your web, mobile, and enterprise apps from critical vulnerabilities like SQL Injection, XSS, and malware, ensuring they remain secure, stable, and trustworthy for your customers and employees.</p>
                    </div>

                    {/* SmartDevices */}
                    <div className={`tab-pane fade${activeTab === "SmartDevices" ? " show active" : ""}`} role="tabpanel">
                     <p>Connected devices bring convenience but also new risks. We safeguard your IoT devices, smart office systems, and workplace technology against exploitation and hijacking, ensuring they work for you—not for cybercriminals.</p>
                    </div>

                     {/* CloudDataSecurity */}
                    <div className={`tab-pane fade${activeTab === "CloudDataSecurity" ? " show active" : ""}`} role="tabpanel">
                     <p>Your data is your most valuable asset. We keep it encrypted, compliant, and safe from leaks or breaches—whether stored on-premises or in the cloud. Our solutions help you stay aligned with GDPR, HIPAA, PCI DSS, and ISO standards, giving you both security and compliance confidence.</p>
                    </div>

                      {/* RealMonitoringAlerts */}
                    <div className={`tab-pane fade${activeTab === "RealMonitoringAlerts" ? " show active" : ""}`} role="tabpanel">
                     <p>Cyber threats don’t wait—and neither do we. With 24/7 monitoring, instant alerts, and rapid response, we detect and neutralize risks before they disrupt your business. Our proactive defense keeps you always one step ahead of attackers.</p>
                    </div>



                  </div>
                </div>
              </div>
                          
                          
                      </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="about-usright-content">
                          <img src={cyberImage2} alt="cybersecurity" />
                      </div>
                    </div>
                 </div>

              </div>
          </div>

             <div className="about-us-main-wrap">
               <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="about-usleft-content text-center">
                         <h2>Our Proven Approach to Security</h2>
                         <p>At [Your Company Name], we don’t wait for threats to strike—we stop them before they reach you. Our proactive, layered, and adaptive approach ensures your business is always protected with advanced monitoring, continuous updates, and rapid response. Unlike traditional models that only react after damage is done, we provide end-to-end protection designed to safeguard your data, applications, networks, and cloud environments at all times. Our approach is built on three core pillars of protection:</p>
                      </div>
                    </div>
                 </div>
                 <div className="row two-img-abt">
                  <div className="col-lg-5">
                      <div className="about-usright-content">
                     <img src={approachImg} alt="approach-img" />
                     </div>
                    </div>
                  <div className="col-lg-7">
                    <div className="about-usleft-content">
                    <div className="second-card-section">
                          <ul>
                              <li>
                                <i class="fa-sharp fa-solid fa-bug"></i>
                                <h3>Prevention </h3>
                                <p>Strong security begins with stopping threats before they strike. We identify vulnerabilities early using continuous risk assessments, penetration testing, and advanced scanning. By deploying proactive safeguards like firewalls, endpoint protection, and access controls, we block threats at the source, ensuring your business runs smoothly without unexpected interruptions.</p>
                              </li>
                              <li>
                                <i class="fa fa-clipboard"></i>
                                <h3>Resilience </h3>
                                <p>Cybersecurity isn’t a one-time setup—it’s a long-term commitment. We build resilience into your systems with adaptive security frameworks, regular updates, threat intelligence, and evolving defense strategies. This means your organization can withstand, adapt to, and recover quickly from cyber incidents while keeping operations uninterrupted.</p>
                              </li>
                              <li>
                                <i class="fa fa-bug-slash"></i>
                                <h3>Innovation </h3>
                                <p>We believe security should empower growth, not hold it back. Our approach enables your business to embrace digital transformation, cloud adoption, IoT, and modern technologies securely. With innovation-driven security, you gain the confidence to explore new opportunities, knowing your critical assets are protected every step of the way. With us, you gain more than just cybersecurity—you gain a trusted partner committed to protecting your digital world, so you can focus on growth and innovation with peace of mind.</p>
                              </li>
                            </ul>
                         </div>
                         </div>
                  </div>
                 </div>
             </div>
          </div>

        {/* -- DESCRIBE ABOUT US ------ */}



        <div className="section">
              <div className="half-container">
              <h2>
              Our Security <span className="accent">PROFESSIONALS</span> with Top
              </h2>
              <p className="sub">Certifications</p>

              <div className="grid">
              <div className="card">
              <img
                src={certifiedLogos}
                alt="All security certifications"
              />
              </div>
              </div>
              </div>
        </div>
        <div className="testimonials-wrap-area bg-color-add p-tb">
        <div className="container">
          <div className="section-title white-title">
            <h2>What Our Clients Say About Us</h2>
            <p>Our clients trust us because we deliver real results, stronger security, and complete peace of mind. Here’s what they have to say:</p>
          </div>
          <div className="carousel" aria-label="Testimonials carousel">
            <div className="viewport">
              <div className="track">
                <article className="card" aria-hidden="false">
                  <p> “The team at Pranasrishti Solutions has transformed the way we approach cybersecurity. Their proactive support and expertise give us confidence that our business is always protected.”</p>
                  <h3>Patric Watler</h3>
                  <span className="role">Manager</span>
                  <div className="stars">★★★★★</div>
                </article>
                <article className="card" aria-hidden="false">
                  <p>“Reliable, responsive, and professional — they don’t just secure our systems, they make us feel safe to grow.”</p>
                  <h3>Jane Anderson</h3>
                  <span className="role">Developer</span>
                  <div className="stars">★★★★★</div>
                </article>
                <article className="card" aria-hidden="false">
                  <p> “With their 24/7 monitoring and quick response, we no longer worry about threats. We know we’re in safe hands.”</p>
                  <h3>Victor James</h3>
                  <span className="role">Designer</span>
                  <div className="stars">★★★★★</div>
                </article>
                <article className="card" aria-hidden="false">
                  <p> “The team at Pranasrishti Solutions has transformed the way we approach cybersecurity. Their proactive support and expertise give us confidence that our business is always protected.”</p>
                  <h3>Patric Watler</h3>
                  <span className="role">Manager</span>
                  <div className="stars">★★★★★</div>
                </article>
              </div>
            </div>
            <div className="dots" aria-hidden="false"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;